import React from 'react';
import { Route, Routes } from 'react-router-dom';
import getHeaders from '../../routes/headerRoutes';

const HeaderRoutes = () => {
	return (
		<Routes>
			{getHeaders().map((page) => (
				<Route key={page.path} {...page} />
			))}
		</Routes>
	);
};

export default HeaderRoutes;
